import React, { FunctionComponent } from 'react';
import { TbLayoutSidebarLeftCollapse } from 'react-icons/tb';
import { IWidgetPersonalNotesListCollapseProps } from './types';

export const WidgetPersonalNotesListCollapse: FunctionComponent<IWidgetPersonalNotesListCollapseProps> = ({
  className,
  iconClassName = 'transition2',
  onClick,
  collapsed = false,
}) => {
  const rootClass = [
    'widget-personal-notes-list-collapse',
    collapsed ? 'widget-personal-notes-list-collapse--collapsed' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClass}>
      <button
        type="button"
        className="btn-badge darkGray-bg widget-personal-notes-list-collapse__toggle"
        style={{
          width: 27,
          height: 27,
          lineHeight: `${27}px`,
        }}
        onClick={onClick}
        title={'Collapse or expand notes list'}
        aria-label={'Collapse or expand notes list'}
      >
        <TbLayoutSidebarLeftCollapse className={iconClassName} style={{ transition: 'none' }} size={15} />
      </button>
    </div>
  );
};
